import { render, staticRenderFns } from "./InternationalBodyCheck.vue?vue&type=template&id=64e856ae&scoped=true&"
import script from "./InternationalBodyCheck.vue?vue&type=script&lang=js&"
export * from "./InternationalBodyCheck.vue?vue&type=script&lang=js&"
import style0 from "./InternationalBodyCheck.vue?vue&type=style&index=0&id=64e856ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e856ae",
  null
  
)

export default component.exports